import React, { useEffect, useState } from 'react';
import _get from 'lodash.get';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import Cookie from 'utils/cookies';
import Card from 'components_v2/common/CardV2/Card';
import {
  getGeoCountry,
  getPrcCookieValue,
  setPayloadInfo,
  getEncTicket,
  checkGracePeriod,
  checkPreExpireDate,
  getPreExpiryFormattedTime,
  getGraceFormattedTime,
  checkIfOneDayRemaining,
} from 'utils/primeUtil';
import {
  newPlanpageMetaData,
  redirectToNewPlanpage,
  sendDataToGAWithGRX,
} from 'components/ToiSubscription/utils/redirectionToPlanPage';
import { gaWrapper } from '../../../helpers/analytics';

import {
  collectEventfireGa4,
  fireCustomDimension,
  getGa4PageViewSet,
} from '../../../utils/common';
import s from './TOIPlusWidget.scss';
import {
  NEW_PLANPAGE_URL,
  TOI_EPAPER_URL_MWEB,
  TOI_EPAPER_URL_WEB,
} from '../../../constants';
import Image from '../../../components/Image';

function TOIPlusWidget({
  item,
  isPrime,
  translationData,
  userPrcData,
  isArticleShow,
  isLiveBlog,
  isUShomepage,
  userData,
  msid,
  isWapView,
}) {
  const prcStatus = getPrcCookieValue();
  const isLoggedIn = !!(Cookie.get('ssoid') || Cookie.get('ssoId'));
  const gaLabel = `Ps-${isLoggedIn ? prcStatus : -1}`;
  const [widgetLabels, setWidgetLabels] = useState(null);
  const [isSaleLive, setisSaleLive] = useState(false);
  const [graceDate, setGraceDate] = useState();
  const [daysRemaining, setDaysRemaining] = useState();
  const [isGracePeriod, setGracePeriod] = useState(false);
  const [ispreExpired, setIsPreExpired] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(
    () => {
      if (userPrcData) {
        checkGracePeriod(userPrcData).then(res => {
          setGracePeriod(res);
        });
        checkPreExpireDate(userPrcData).then(res => {
          setIsPreExpired(res);
        });
        getPreExpiryFormattedTime(userPrcData).then(res => {
          setDaysRemaining(res);
        });
        getGraceFormattedTime(userPrcData).then(res => {
          setGraceDate(res);
        });
      }
    },
    [userPrcData],
  );

  useEffect(
    () => {
      const widgetNode = translationData?.rhsTOIWidget;
      if (widgetNode) {
        if (isGracePeriod && widgetNode.grace) {
          setWidgetLabels(widgetNode.grace);
        } else if (ispreExpired && widgetNode.preExpiry) {
          setWidgetLabels(widgetNode.preExpiry);
        } else if (widgetNode[`prc${prcStatus || 0}`]) {
          setWidgetLabels(widgetNode[`prc${prcStatus || 0}`]);
        }
      }
    },
    [translationData, isGracePeriod, ispreExpired],
  );

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  const { data, path, epaperFrontImage, epaperDefaultImage } = item;

  const getPageName = () => {
    if (isLiveBlog) {
      return 'liveblog';
    }
    if (isArticleShow) {
      return 'articleshow';
    }
    if (isUShomepage) {
      return 'homepageUS';
    }
    return 'homepage';
  };

  const fireGA4 = obj => {
    const gaPageViewObj = getGa4PageViewSet() || {};
    const collatedGadata = {
      ...gaPageViewObj,
      event: 'select_item',
    };
    return collectEventfireGa4(collatedGadata, {
      item_name:
        window.location.href.indexOf('.cms') > -1
          ? document.title
          : window.location.href,
      item_id: msid || '',
      item_brand: 'product_interventions',
      item_category: 'Nudges',
      item_category2: getPageName(),
      item_category3: obj?.item_category3 ? obj?.item_category3 : 'N/A',
      item_category4: obj?.item_category4 ? obj?.item_category4 : 'N/A',
      location_id: obj?.location_id ? obj?.location_id : 'N/A',
    });
  };

  const onWidgetClick = ({ event, EA, CD, CTA, url }) => {
    event.preventDefault();
    gaWrapper('send', 'event', 'WEB-IN-NHP1', EA, `${gaLabel}`);
    if (CD) {
      fireCustomDimension(CD, 'dimension31');
    }
    if (CTA) {
      // const grxParams = [
      //   'paywall',
      //   {
      //     client_source: 'cdp',
      //     event_nature: 'click',
      //     event_category: 'subscription',
      //     cta_text: event.target.innerText,
      //   },
      // ];
      // if (typeof window?.grx_module?.hitPaywallEventReact === 'function') {
      //   window.grx_module.hitPaywallEventReact(...grxParams);
      // } else {
      //   window.Times.setGRXDataInLocalStorage('GRX_QUEUE_EVENT', {
      //     eventName: grxParams[0],
      //     payload: grxParams[1],
      //   });
      // }
      fireGA4({
        item_category4: event.target.innerText || '',
        item_category3: CTA,
      });
    }
    window.location.href = url;
  };

  const getAnalyticsMetaData = () => {
    let nudgeCategory = 'homepage_inline_nudge_subscribe';
    if (isGracePeriod) {
      nudgeCategory = 'Grace_Homepage_Inline_Nudge';
    } else if (ispreExpired) {
      nudgeCategory = 'EarlyRenew_Homepage_Inline_Nudge';
    } else {
      nudgeCategory = 'homepage_inline_nudge_subscribe';
    }

    return {
      acqSubSource: nudgeCategory,
      item_category3: nudgeCategory,
    };
  };

  const redirection = () => {
    const getUnifiedNodes =
      translationData?.unifiedNodes[`prc${prcStatus || 0}`];
    if (isLoggedIn) {
      getEncTicket(false).then(val => {
        window.location.href = redirectToNewPlanpage(
          newPlanpageMetaData(
            {
              unifiedNodes: getUnifiedNodes,
              acqSubSource: getAnalyticsMetaData().acqSubSource,
            },
            val,
          ),
        );
      });
    } else {
      window.location.href = redirectToNewPlanpage(
        newPlanpageMetaData({
          unifiedNodes: getUnifiedNodes,
          acqSubSource: getAnalyticsMetaData().acqSubSource,
        }),
      );
    }
  };

  const createGA4Object = e => ({
    accessiblefeatures: userPrcData?.accessibleFeatures,
    source: userPrcData?.source,
    accessType: userPrcData?.accessType,
    objUserData: {
      email:
        typeof userData?.getEmail !== 'undefined' ? userData?.getEmail() : '',
      fname:
        typeof userData?.getFirstName !== 'undefined'
          ? userData?.getFirstName()
          : '',
    },
    ga4Items: fireGA4({
      item_category4: e.target.innerText || '',
      item_category3: getAnalyticsMetaData().item_category3,
    }),
  });

  const handleSubscribeNowCTA = e => {
    e.preventDefault();
    gaWrapper(
      'send',
      'event',
      'WEB-IN-NHP1',
      'Widget_TOIPlus_Subscribe',
      `${gaLabel}`,
    );
    setPayloadInfo('Header-NewTOIPlusCTA-Click', 'NON_STORY');
    if (window !== 'undefined') {
      if (e.target) {
        const grxParams = [
          'paywall',
          {
            client_source: 'cdp',
            event_nature: 'click',
            event_category: 'subscription',
            cta_text: e.target.innerText,
          },
        ];
        if (typeof window?.grx_module?.hitPaywallEventReact === 'function') {
          window.grx_module.hitPaywallEventReact(...grxParams);
        } else {
          window.Times.setGRXDataInLocalStorage('GRX_QUEUE_EVENT', {
            eventName: grxParams[0],
            payload: grxParams[1],
          });
        }
        const dataToBepassed = createGA4Object(e);
        sendDataToGAWithGRX(dataToBepassed)
          .then(redirection)
          .catch(redirection);
      }
    }
  };

  const getImageElement = () => {
    if (
      epaperFrontImage?.data &&
      epaperFrontImage.data.msid &&
      epaperFrontImage.data.imageDate &&
      epaperFrontImage.data.imageSize &&
      new Date(epaperFrontImage.data.imageDate)?.setHours(0, 0, 0, 0) ===
        new Date().setHours(0, 0, 0, 0)
    ) {
      const imgWidth = epaperFrontImage.data?.imageDim?.imageWidth || 600;
      const imgQuality = `quality-${epaperFrontImage.data?.imageDim
        ?.imageQuality || 80}`;
      return (
        <div className={s.image_box_wrapper}>
          <Image
            msid={epaperFrontImage.data.msid}
            src={`https://static.toiimg.com/thumb/imgsize-${
              epaperFrontImage.data.imageSize
            },msid-${
              epaperFrontImage.data.msid
            },width-${imgWidth},resizemode-4,${imgQuality}/${
              epaperFrontImage.data.msid
            }.jpg`}
            imgsize={epaperFrontImage.data.imageSize}
            lazyload={false}
          />
        </div>
      );
    } else if (
      epaperDefaultImage?.data &&
      epaperDefaultImage.data.msid &&
      epaperDefaultImage.data.imageSize
    ) {
      const imgWidth = epaperFrontImage.data?.imageDim?.imageWidth || 300;
      const imgQuality = `quality-${epaperFrontImage.data?.imageDim
        ?.imageQuality || 80}`;
      return (
        <div className={s.image_box_wrapper}>
          <Image
            msid={epaperDefaultImage.data.msid}
            src={`https://static.toiimg.com/thumb/imgsize-${
              epaperDefaultImage.data.imageSize
            },msid-${
              epaperDefaultImage.data.msid
            },width-${imgWidth},resizemode-4,${imgQuality}/${
              epaperDefaultImage.data.msid
            }.jpg`}
            imgsize={epaperDefaultImage.data.imageSize}
            lazyload={false}
          />
        </div>
      );
    }
    return null;
  };

  const getRenewStrip = () => {
    let returnedValue = null;
    if (isGracePeriod) {
      const gracePeriodHeading = widgetLabels?.h2?.replace(
        '<gracedate>',
        `${graceDate}`,
      );

      returnedValue = (
        <div className={s.renew_strip_container}>
          {widgetLabels?.h1 && (
            <div
              className={s.renewalHeading}
              dangerouslySetInnerHTML={{
                __html: widgetLabels?.h1,
              }}
            />
          )}
          {gracePeriodHeading && (
            <div
              className={s.renewalSubHeading}
              dangerouslySetInnerHTML={{
                __html: gracePeriodHeading,
              }}
            />
          )}
          <div className={s.renewal_button} onClick={handleSubscribeNowCTA}>
            {widgetLabels?.ctaText}
          </div>
        </div>
      );
    } else if (ispreExpired) {
      const oneDayRemaining = checkIfOneDayRemaining(daysRemaining);
      const days = !oneDayRemaining ? `${daysRemaining} days` : 'Today';
      const daysText = widgetLabels?.h1?.replace(
        `<span class='expriedaysremaining'><remainingDays></span>`,
        `${
          !oneDayRemaining ? 'in' : ''
        } <span class=expriedaysremaining>${days}</span>`,
      );

      const preExprieSubheading = widgetLabels?.h2;
      returnedValue = (
        <div className={s.renew_strip_container}>
          <div className={s.logo} />
          {daysText && (
            <div
              className={s.renewalHeading}
              dangerouslySetInnerHTML={{
                __html: daysText,
              }}
            />
          )}
          {preExprieSubheading && (
            <div
              className={s.renewalSubHeading}
              dangerouslySetInnerHTML={{
                __html: preExprieSubheading,
              }}
            />
          )}
          <div className={s.renewal_button} onClick={handleSubscribeNowCTA}>
            {widgetLabels?.ctaText}
          </div>
        </div>
      );
    }
    return returnedValue;
  };

  // For christmas sale
  useEffect(() => {
    const geoCountry = getGeoCountry();
    const endDate =
      geoCountry === 'IN'
        ? new Date('Dec 26, 2021 23:59:00').getTime()
        : new Date('Dec 31, 2021 23:59:00').getTime();
    const startDate = new Date('Dec 22, 2021 23:00:00').getTime();
    const todayDate = Date.now();
    const passedTime = todayDate - startDate;
    const remainingTime = endDate - todayDate;
    if (passedTime >= 0 && remainingTime >= 0) {
      setisSaleLive(true);
    } else {
      setisSaleLive(false);
    }
  }, []);

  // end here

  if (isWapView) {
    return (
      <div className={s.full_width}>
        <Link
          type="button"
          to={isWapView ? TOI_EPAPER_URL_MWEB : TOI_EPAPER_URL_WEB}
          onClick={e =>
            onWidgetClick({
              event: e,
              EA: 'Widget_TOIPlus_ePaper',
              CD: '',
              CTA: 'homepage_inline_nudge_epaper',
              url:
                widgetLabels?.subTextCTALink ||
                (isWapView ? TOI_EPAPER_URL_MWEB : TOI_EPAPER_URL_WEB),
            })
          }
        >
          <div className={s.image_box}>{getImageElement()}</div>
        </Link>
        <Link
          type="button"
          to={isWapView ? TOI_EPAPER_URL_MWEB : TOI_EPAPER_URL_WEB}
          className={s.button_box}
          onClick={e =>
            onWidgetClick({
              event: e,
              EA: 'Widget_TOIPlus_ePaper',
              CD: '',
              CTA: 'homepage_inline_nudge_epaper',
              url:
                widgetLabels?.subTextCTALink ||
                (isWapView ? TOI_EPAPER_URL_MWEB : TOI_EPAPER_URL_WEB),
            })
          }
        >
          Subscribe to read TOI ePaper
        </Link>
      </div>
    );
  }

  return (
    <>
      <div
        className={`${s.toiplus_widget} ${isSaleLive ? s.sale_widget : ''} ${
          isLiveBlog ? s.margin_bottom : ''
        }`}
      >
        {(isGracePeriod || ispreExpired) && widgetLabels && getRenewStrip()}
        <div className={s.toiplus_widget_head}>
          <Link
            type="button"
            className={s.toiplus_widget_desc}
            to={widgetLabels?.subTextCTALink || TOI_EPAPER_URL_WEB}
            onClick={e =>
              onWidgetClick({
                event: e,
                EA: 'Widget_TOIPlus_ePaper',
                CD: '',
                CTA: 'homepage_inline_nudge_epaper',
                url: widgetLabels?.subTextCTALink || TOI_EPAPER_URL_WEB,
              })
            }
          >
            {widgetLabels?.subTextCTA || `${"Today's ePaper"}`}
          </Link>
          {!isPrime && (
            <Link
              type="button"
              className={s.toiplusButton}
              to={widgetLabels?.ctaLink || NEW_PLANPAGE_URL}
              onClick={e => {
                handleSubscribeNowCTA(e);
              }}
            >
              {widgetLabels?.ctaText || 'Subscribe'}
            </Link>
          )}
        </div>
        <div
          className={`${s.content} ${
            isArticleShow || isLiveBlog ? s.tiny_width : ''
          }`}
        >
          <Link
            type="button"
            className={s.toiplus_widget_img}
            to={widgetLabels?.subTextCTALink || TOI_EPAPER_URL_WEB}
            onClick={e =>
              onWidgetClick({
                event: e,
                EA: 'Widget_TOIPlus_ePaper_img',
                CD: '',
                CTA: 'homepage_inline_nudge_epaper',
                url: widgetLabels?.subTextCTALink || TOI_EPAPER_URL_WEB,
              })
            }
          >
            {getImageElement()}

            <div className={s.card}>
              <div className={`${isLoaded ? s.card_inner : ''}`}>
                <div className={s.card_front} />
                {isLoaded && (
                  <div className={s.card_back}>
                    <div className={s.arrow}>
                      <img
                        src="https://static.toiimg.com/photo/110075966.cms"
                        alt="base"
                        className={s.base}
                      />
                      <img
                        src="https://static.toiimg.com/photo/110075971.cms"
                        alt="arrow"
                        className={s.arrow_anim}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Link>

          <span className={s.divider} />
          <div className={s.logoAndtext}>
            <Link
              href={path}
              className={s.site_logo}
              onClick={e =>
                onWidgetClick({
                  event: e,
                  EA: 'Widget_TOIPlus_stories',
                  CD: '',
                  CTA: 'homepage_inline_nudge_ExclusiveStories',
                  url: path,
                })
              }
            >
              TOI+
            </Link>
            <Link
              to={widgetLabels?.subTextCTA2Link || path}
              className={s.read_more}
              onClick={e =>
                onWidgetClick({
                  event: e,
                  EA: 'Widget_TOIPlus_stories',
                  CD: '',
                  CTA: 'homepage_inline_nudge_ExclusiveStories',
                  url: widgetLabels?.subTextCTA2Link || path,
                })
              }
            >
              {widgetLabels?.subTextCTA2 || 'Exclusive Stories'}
            </Link>
          </div>
          {data &&
            Array.isArray(data) &&
            data.length > 0 &&
            data?.slice(0, 3)?.map(_item => (
              <Card
                data={_item}
                itemClass={s.news_card}
                noImage
                plusIconNotRequired
                onClick={e =>
                  onWidgetClick({
                    event: e,
                    EA: `Widget_TOIPlus_storyno-${_item.gaindex}_${_item.hl}`,
                    CD: _item.id,
                    CTA: `homepage_inline_nudge_Story_${_item.id}`,
                    url: _item.wu,
                  })
                }
              />
            ))}
        </div>
      </div>
    </>
  );
}

TOIPlusWidget.propTypes = {
  item: PropTypes.shape({
    data: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        hl: PropTypes.string,
        image: PropTypes.shape({}),
        du: PropTypes.string,
        imageid: PropTypes.string,
        wu: PropTypes.string,
      }),
    ),
    path: PropTypes.string,
    epaperDefaultImage: PropTypes.shape({
      data: PropTypes.shape({
        msid: PropTypes.string,
        imageSize: PropTypes.string,
        imageDim: PropTypes.shape({
          imageWidth: PropTypes.string,
          imageQuality: PropTypes.string,
        }),
      }),
    }),
    epaperFrontImage: PropTypes.shape({
      data: PropTypes.shape({
        msid: PropTypes.string,
        imageSize: PropTypes.string,
        imageDate: PropTypes.string,
        imageDim: PropTypes.shape({
          imageWidth: PropTypes.string,
          imageQuality: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,
  isPrime: PropTypes.bool,
  translationData: PropTypes.shape({
    rhsTOIWidget: PropTypes.shape({}),
    unifiedNodes: PropTypes.shape({}),
  }).isRequired,
  // eslint-disable-next-line react/require-default-props
  // isFactsheet: PropTypes.bool,
  isLiveBlog: PropTypes.bool,
  msid: PropTypes.string,
  userData: PropTypes.shape({}),
  userPrcData: PropTypes.shape({}),
  isArticleShow: PropTypes.bool,
  isUShomepage: PropTypes.bool,
  isWapView: PropTypes.bool,
};

TOIPlusWidget.defaultProps = {
  isPrime: false,
  isLiveBlog: false,
  msid: '',
  userData: {},
  userPrcData: {},
  isArticleShow: false,
  isUShomepage: false,
  isWapView: false,
};

const mapStateToProps = state => ({
  translationData: _get(state, 'translationConfig.nudges', {}),
  userPrcData: state.login.userPrcData,
  userData: state.login.userData,
});

export default connect(mapStateToProps)(TOIPlusWidget);
